import { render, staticRenderFns } from "./Prison.vue?vue&type=template&id=3bb8076a"
import script from "./Prison.vue?vue&type=script&lang=js"
export * from "./Prison.vue?vue&type=script&lang=js"
import style0 from "./Prison.vue?vue&type=style&index=0&id=3bb8076a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports